import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { components } from '@doltech/dto';
import { ActivityTypeEnum } from '@doltech/utils/lib/constants';

interface UserActiveDTO {
  sessionId: string;
  type?: ActivityTypeEnum;
  userId: string;
  activeAt: string;
}

export const postUserActivity = async (requestBody: UserActiveDTO, userId) => {
  const response = await apis.kafkaRest.post<components['schemas']['ResponseDTO']>(
    apiUrls.kafkaRest.USER_ACTIVITY_TRACKING,
    {
      records: [
        {
          value: {
            action: 'user-activity:tracking-page-activity',
            byUserId: userId,
            updatedData: requestBody,
          },
        },
      ],
    }
  );
  return response.data;
};
